import ApiUrl from "../../../configTools/apiUrl";
const User = JSON.parse(localStorage.getItem("user-info"));

const Get = (setValues) => {
    fetch(ApiUrl.API_URL_Navigation)
    .then(res=>res.json())
    .then(data =>{
        setValues(data);
    });
}


const Delete = (id,toast,setValues) => {
    if(!window.confirm("Are you sure you want to delete?")){
        return;
    }
    const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
    fetch(ApiUrl.API_URL_NavigationUpdate+"/"+id,{
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            Get(setValues);
            setTimeout(() => {
                toast.update(toastid, { render: "Deleted", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
        else{
          setTimeout(() => {
            toast.update(toastid, { render: data.responce, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
          }, 500);
        }
    });
}

export default {Get,Delete}